// extracted by mini-css-extract-plugin
module.exports = {"field":"search-field_field__2EJ3y","result-block":"search-field_result-block__WrJql"};